import axios from '@/assets/http';

export default {
    getJSAPIticket(params) {
        return axios.get(`/api/tools/getJSAPIticket?url=${params.url}`);
    },
    getShareInfo(params) {
        return axios.get(`/api/common/share`, {
            params: params
        });
    },
    businessCooperation(data) {
        return axios.post(`/api/v1/business/cooperation`, data);
    },
}
